import { Component, Input, OnInit } from "@angular/core";
import { UserAPI } from "../../../../model";
import { AbstractUserApiModalComponent } from "../../abstract-userapi-modal.component";

@Component({
  standalone: false,
  selector: 'app-userapi-afas',
  templateUrl: './userapi-afas.component.html'
})
export class UserApiAfasComponent extends AbstractUserApiModalComponent implements OnInit {
  @Input() userApi: UserAPI;

  test: boolean;
  accept: boolean;
  darkMode: boolean;

  constructor() {
    super();
    this.darkMode = document.documentElement.classList.contains("dark");
  }

  ngOnInit(): void {
    this.test = this.userApi?.customConfig1 === 'test';
    this.accept = this.userApi?.customConfig1 === 'accept';
  }

  isTest(): boolean {
    return this.test;
  }

  isAccept(): boolean {
    return this.accept;
  }

  toggleTest(): void {
    this.test = !this.test;
    this.accept = false;
    this.userApi.customConfig1 = this.test ? 'test' : '';
  }

  toggleAccept(): void {
    this.accept = !this.accept;
    this.test = false;
    this.userApi.customConfig1 = this.accept ? 'accept' : '';
  }
}
